import React, { useState, useEffect } from 'react'
import i18n from 'live/services/i18n'
import WebSettingsCard from 'live/components/ui/admin/web-settings-card'
import FormGroup from 'live/components/forms/ui/form-group'
import ActionToggle from 'live/components/ui/action-toggle'
import globalNotification from 'live/services/global-notification'
const RESOURCE_URL = '/services/plugin-asset-aggregator/configuration/listener'

const Configuration = (): JSX.Element => {
    const [editMode, setEditMode] = useState(false)
    const [saved, setSaved] = useState(false)
    const [loading, setLoading] = useState(true)
    const [configPayload, setConfigPayload] = useState({ milisecondsBetweenCheckpointUpdates: 60000, 
        minimumDurationToLogEventLobby: 1000, 
        minimumDurationToLogControlEvent: 10})

    useEffect(() => {
        fetch(RESOURCE_URL)
            .then(resp => {
                return resp.json()
            })
            .then(data => {
                setConfigPayload(data)
            })
            .catch(error => {
                globalNotification.failed(i18n('Failed to get the path', error))
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const onSave = (): void => {
        const headers = {
            'content-type': 'application/json'
        }

        const body = {
            ...configPayload
        }

        setLoading(true)

        fetch(RESOURCE_URL, { method: 'POST', body: JSON.stringify(body), headers })
            .then(resp => {
                if (resp.status !== 200) return Promise.reject(resp)
                setEditMode(false)
                setSaved(true)
                globalNotification.success(i18n('Settings successfully saved'))
            })
            .catch(error => {
                error.json().then(payload => {
                    globalNotification.error(i18n('Failed to save settings') + ': ' + i18n(payload.message))
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <WebSettingsCard
            name="aggregator-report-config"
            className="live-feature"
            open={editMode}
            error={''}
            saved={saved}
            save={onSave}
            hideButton={loading}
            savedMessage={i18n('Aggregator Configuration settings successfully saved')}
            toggle={(name, status) => {
                setEditMode(status === 'open')
                setSaved(status !== 'open')
            }}
        >
            <h2>{i18n('Listener Configuration')}</h2>
            {loading ? <span>{i18n('Loading from server...')}</span> : (
                <>
                    <FormGroup
                        type="number"
                        label={i18n('Checkpoint Update Interval')}
                        name="milisecondsBetweenCheckpointUpdates"
                        value={configPayload.milisecondsBetweenCheckpointUpdates}
                        placeholder=""
                        hideInput={!editMode}
                        onChange={({ target }) => {
                            setConfigPayload({ ...configPayload, milisecondsBetweenCheckpointUpdates: target.value })
                        }}
                        help={i18n("It's recommended this setting to never be bellow 60000 (60 seconds) as the lower the number greater the chance SQL may be flooded.")}
                    />
                    <FormGroup
                        type="number"
                        label={i18n('Minimum duration of eventLobby.enter for logging')}
                        name="minimumDurationToLogEventLobby"
                        value={configPayload.minimumDurationToLogEventLobby}
                        placeholder=""
                        hideInput={!editMode}
                        onChange={({ target }) => {
                            setConfigPayload({ ...configPayload, minimumDurationToLogEventLobby: target.value })
                        }}
                        help={i18n("Minimum duration of eventLobby.enter so we log this as a (bad) performance event. Recommended to be always above 100.")}
                    />
                    <FormGroup
                        type="number"
                        label={i18n('Minimum duration of controlEvent for logging')}
                        name="minimumDurationToLogControlEvent"
                        value={configPayload.minimumDurationToLogControlEvent}
                        placeholder=""
                        hideInput={!editMode}
                        onChange={({ target }) => {
                            setConfigPayload({ ...configPayload, minimumDurationToLogControlEvent: target.value })
                        }}
                        help={i18n("Minimum duration of controlEvent so we log this as a (bad) performance event. Recommended to be always above 10.")}
                    />
                </>
            )}
        </WebSettingsCard>
    )
}

export default {
    name: i18n('Configuration'),
    key: 'aggregator-listener-config',
    section: i18n('Asset Aggregator Settings'),
    configComponent: Configuration
}
